<template>
  <div class="yes-no-us" v-if="isUs">
    <button
      v-on:click="usYesAction()"
      :class="['yes-action-us', answer == yes ? 'active' : '', answer == no ? 'inactive' : '']"
    >
      Yes
    </button>
    <button
      v-on:click="usNoAction()"
      :class="['no-action-us', answer == no ? 'active' : '', answer == yes ? 'inactive' : '']"
    >
      No
    </button>
  </div>

  <table :class="'radio-btn-set buttons-wrapped yes-no ' + className" v-else>
    <tbody>
      <tr>
        <td>
          <input type="radio" v-model="answer" :value="yes" :id="yesId" :name="id" :autocomplete="autocomplete" />
          <label :for="yesId">Yes</label>
        </td>

        <td>
          <input type="radio" v-model="answer" :value="no" :id="noId" :name="id" :autocomplete="autocomplete" />
          <label :for="noId">No</label>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["value", "yes", "no", "id", "className", "preventAutocomplete"],
  inject: ["isUs"],
  data: function () {
    return {
      answer: this.value,
      yesId: "yes-" + this.id,
      noId: "no-" + this.id,

      // Modify browser autocomplete when prevention is requested, and
      // otherwise don't touch the attribute at all.
      autocomplete: !!this.preventAutocomplete ? "off" : undefined,
    };
  },
  methods: {
    usYesAction: function () {
      this.answer = this.$props.yes;
    },
    usNoAction: function () {
      this.answer = this.$props.no;
    },
  },
  watch: {
    answer: function (newValue) {
      this.$emit("input", newValue);
    },
  },
});
</script>
